export interface UsernameInterface {
  username: string;
}

export class Username implements UsernameInterface {
  public username: string;

  constructor(username: string) {
    this.username = username;
  }
}
